import { GENERIC_CONST, type GenericProps } from './Generic.d';
import { Generic } from './Generic.styles';

export const GenericBase = ({ successMsg, tip }: GenericProps) => (
  <Generic.SuccessMsg data-testid={GENERIC_CONST.TEST_ID}>
    <Generic.SuccessText textAlign="center" variant="body-large-short">
      {successMsg}
    </Generic.SuccessText>

    {tip && (
      <Generic.SuccessText textAlign="center" variant="auxiliar-small">
        {tip}
      </Generic.SuccessText>
    )}
  </Generic.SuccessMsg>
);

export default GenericBase;
